// extracted by mini-css-extract-plugin
export var dividerLine = "_al-3";
export var itemImage = "_al-9";
export var lightDivider = "_al-4";
export var modalContent = "_al-5";
export var modalContentCompact = "_al-6";
export var productCard = "_al-a";
export var productImage = "_al-b";
export var productImageCompact = "_al-7";
export var productImagePlaceholder = "_al-c";
export var productImagePlaceholderCompact = "_al-8";
export var progressBarBackground = "_al-1";
export var progressBarContainer = "_al-0";
export var progressBarFill = "_al-2";